import * as Yup from 'yup';
import { MESSAGE_MIN_LENGTH, MESSAGE_MAX_LENGTH, DrivingSchoolsType } from './constants';
import { FormState } from './SmallResolution/enums';

export const validationSchema = Yup.object().shape({
  stars: Yup.string()
    .required('Ce champ est obligatoire.'),
  textareaField: Yup.string()
    .trim()
    .required('Ce champ est obligatoire.')
    .min(MESSAGE_MIN_LENGTH, `Veuillez fournir au moins ${MESSAGE_MIN_LENGTH} caractères.`)
    .max(MESSAGE_MAX_LENGTH, `Votre avis est trop long ! Nous limitons la longueur des avis à ${MESSAGE_MAX_LENGTH} caractères… essayez de le raccourcir un peu.`),

  isAgreed: Yup.bool()
    .oneOf([true], 'Veuillez accepter les Conditions générales de publication des avis.'),
  examDate: Yup.date().required('Ce champ est obligatoire.').typeError('Ce champ doit être une date (jj/mm/aaaa).'),
});

export const validationSchemaSmallScreen = {
  [FormState.Stars]: Yup.object().shape({
    stars: Yup.string()
      .required('Ce champ est obligatoire.'),
  }),
  [FormState.ExamCenter]: Yup.object().shape({
    textareaField: Yup.string()
      .trim()
      .required('Ce champ est obligatoire.')
      .min(MESSAGE_MIN_LENGTH, `Veuillez fournir au moins ${MESSAGE_MIN_LENGTH} caractères.`)
      .max(MESSAGE_MAX_LENGTH, `Votre avis est trop long ! Nous limitons la longueur des avis à ${MESSAGE_MAX_LENGTH} caractères… essayez de le raccourcir un peu.`),
    examDate: Yup.date().required('Ce champ est obligatoire.').typeError('Ce champ doit être une date (jj/mm/aaaa).'),
  }),
  [FormState.StudyType]: Yup.object().shape({
    drivingSchoolType: Yup.string().required('Ce champ est obligatoire.'),
    helpSearchSchool: Yup.string().oneOf(['0', '1']),
    isAgreed: Yup.bool()
      .when(['drivingSchoolType', 'helpSearchSchool'], {
        is: (drivingSchoolType, helpSearchSchool) => drivingSchoolType === DrivingSchoolsType.TRADITIONAL || helpSearchSchool === '0',
        then: Yup.bool()
          .oneOf([true], 'Veuillez accepter les Conditions générales de publication des avis.'),
      }),
  }),
  [FormState.DataTransferForm]: Yup.object().shape({
    zipcode: Yup.string().when(['drivingSchoolType', 'helpSearchSchool'], {
      is: (drivingSchoolType, helpSearchSchool) => drivingSchoolType !== DrivingSchoolsType.TRADITIONAL && helpSearchSchool === '1',
      then: Yup.string()
        .matches(/^[0-9]{5}$/, 'Ce champ doit comporter 5 chiffres.')
        .required('Ce champ est obligatoire.'),
    }),
    phone: Yup.string()
      .when(['drivingSchoolType', 'helpSearchSchool'], {
        is: (drivingSchoolType, helpSearchSchool) => drivingSchoolType !== DrivingSchoolsType.TRADITIONAL && helpSearchSchool === '1',
        then: Yup.string()
          .matches(
            /^(?:(?:)0)\s*[1-7,9](?:[\s.-]*\d{2}){4}$/,
            'Le téléphone doit être au format 01 23 45 67 89 et ne doit pas commencer par \'08\'',
          )
          .required('Ce champ est obligatoire.'),
      }),
    isAgreed: Yup.bool()
      .oneOf([true], 'Veuillez accepter les Conditions générales de publication des avis.'),
  }),
};

export const formInitialValues = {
  stars: '',
  registrationRate: '',
  waitingRoomRate: '',
  examRoomRate: '',
  equipmentRate: '',
  resultAvailabilityRate: '',
  textareaField: '',
  isAgreed: false,
  examDate: undefined,
  drivingSchoolType: DrivingSchoolsType.TRADITIONAL,
  helpSearchSchool: '1',
};

export const formInitialValuesSmallScreen = {
  ...formInitialValues,
  drivingSchoolType: '',
  zipcode: '',
  phone: '',
};
